import HeroSection from "./components/HeroSection";

export default function Home() {
  return (
    <main className="min-h-screen bg-[#EDEDED]">
      <HeroSection />
    </main>
  );
}